import { DATE_DELIMITER } from 'models/date';
import {
  FormPageAuthInputItemDateFree,
  FormPageInputItemDateFree,
  FormPageInputItemDateYearPulldown,
} from 'shared';
import { buildStringWithDelimiter, isAllStringsFalsy } from './shared';

// ajvで比較したいので月日の値を2桁に揃える
const zeroPaddingIfNeeded = (
  monthOrDay: string | undefined,
): string | undefined => {
  if (monthOrDay == null || monthOrDay === '') {
    return monthOrDay;
  }
  return monthOrDay.padStart(2, '0');
};

type DateValue = {
  year?: string;
  month?: string;
  day?: string;
};
const convertDate = (date: DateValue): string | undefined => {
  const { year, month, day } = date;
  if (isAllStringsFalsy(year, month, day)) {
    return undefined;
  }
  return buildStringWithDelimiter(
    [year, zeroPaddingIfNeeded(month), zeroPaddingIfNeeded(day)],
    DATE_DELIMITER,
  );
};

export const convertDateFree = (
  value: FormPageInputItemDateFree,
): string | undefined => {
  return convertDate(value);
};

export const convertDateYearPulldown = (
  value: FormPageInputItemDateYearPulldown,
): string | undefined => {
  return convertDate(value);
};

export const convertAuthDateFree = (
  value: FormPageAuthInputItemDateFree,
): string | undefined => {
  return convertDate(value);
};
